import { Car, User, Star } from 'lucide-react';

const STATS = [
  { value: '500+', label: 'Rides completed' },
  { value: '1500+', label: 'Drivers onboard' },
  { value: '2K+', label: 'Riders' },
  { value: '4.8★', label: 'Rating' },
];

const PlayStoreIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M3.18 23.76c.3.17.64.24.99.2l13.7-11.96-2.85-2.85L3.18 23.76zM.54 1.18C.2 1.56 0 2.13 0 2.87v18.26c0 .74.2 1.31.54 1.69l.09.08 10.23-10.23v-.24L.63 1.1l-.09.08zM20.66 10.53l-2.91-1.66-3.19 3.19 3.19 3.19 2.93-1.67c.84-.48.84-1.57-.02-2.05zM4.17.24l13.58 7.74-2.85 2.85L4.17.24z" />
  </svg>
);

// Flat split hero: left = headline + form-equivalent CTA stack, right = a
// single bounded illustration panel (real app screenshot). No gradients,
// no blur, no glow — color lives in the screenshot, not the chrome.
const HeroSection = () => {
  return (
    <section className="bg-white dark:bg-dark-bg">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-12 lg:py-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* ── LEFT: copy + CTAs ── */}
          <div className="min-w-0 text-left">

            <div className="inline-flex items-center gap-2 mb-6">
              <span className="w-2 h-2 rounded-full bg-teal" />
              <span className="text-sm font-semibold text-teal-dark dark:text-teal">
                Started in Bihar · Expanding across India
              </span>
            </div>

            <h1 className="font-display text-4xl sm:text-5xl font-semibold leading-[1.1] text-ink dark:text-dark-ink mb-4">
              Aapki Apni Sawari
            </h1>

            <p className="text-lg leading-relaxed text-ink-soft dark:text-dark-ink-soft mb-8 max-w-lg">
              India's driver-first ride app. Cheaper fares, no surprise pricing,
              and a booking flow that gets out of your way. Price you see is the
              price you pay.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-10">
              <a
                href="https://play.google.com/store/apps/details?id=com.elt.totowala"
                target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-semibold text-white bg-primary hover:bg-primary-dark transition-colors w-full sm:w-auto"
              >
                <User size={16} />
                Download for Riders
                <PlayStoreIcon />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.elt.totowalafordrivers"
                target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-semibold text-ink dark:text-dark-ink border border-line dark:border-dark-line hover:border-ink dark:hover:border-dark-ink transition-colors w-full sm:w-auto"
              >
                <Car size={16} />
                Download for Drivers
                <PlayStoreIcon />
              </a>
            </div>

            <div className="h-px bg-line dark:bg-dark-line mb-6" />

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
              {STATS.map((stat) => (
                <div key={stat.label}>
                  <p className="text-2xl font-bold text-ink dark:text-dark-ink leading-none">{stat.value}</p>
                  <p className="text-xs text-ink-soft mt-1.5">{stat.label}</p>
                </div>
              ))}
            </div>

          </div>{/* end left column */}

          {/* ── RIGHT: bounded illustration panel ── */}
          <div className="w-full min-w-0 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[380px] mx-auto lg:mx-0">
              <div className="rounded-card bg-primary-tint/40 dark:bg-white/5 p-8">
                <img
                  src="/images/illustrations/destination.svg"
                  alt="Set your destination and book a ride"
                  className="w-full h-auto block"
                />
              </div>

              {/* Single trust card, bounded, no overlap with the panel edge */}
              <div className="absolute left-4 -bottom-6 rounded-card px-4 py-3 bg-white dark:bg-dark-surface border border-line dark:border-dark-line shadow-md">
                <div className="flex gap-0.5 mb-1">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <Star key={i} size={12} fill={i <= 4 ? 'var(--color-accent)' : 'none'} color="var(--color-accent)" />
                  ))}
                </div>
                <p className="text-sm font-bold text-ink dark:text-dark-ink leading-none">4.8 / 5</p>
                <p className="text-[10px] text-ink-soft dark:text-dark-ink-soft mt-1">Rider reviews</p>
              </div>
            </div>
          </div>{/* end right column */}

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
